export const AP_SHOW_RESET = "AP_SHOW_RESET";
export const AP_SHOW_SET_ERROR = "AP_SHOW_SET_ERROR";
export const AP_SHOW_SET_RETRIEVED = "AP_SHOW_SET_RETRIEVED";
export const AP_SHOW_TOGGLE_LOADING = "AP_SHOW_TOGGLE_LOADING";
